var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`bg-${_vm.color}-100 border-t border-b border-${_vm.color}-500 text-${_vm.color}-700 px-4 py-3`,attrs:{"role":"alert"}},[(_vm.title)?_c('p',{staticClass:"font-bold"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('p',{staticClass:"text-sm"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }